<mat-dialog-content>
    @if(data.titleLabel) {
        <span class="tw-font-bold tw-text-black">{{ data.titleLabel | translate }}</span>
    }
    @if (safeHtml) {
        <div [ngStyle]="data.customStyle" [innerHTML]="safeHtml"></div>
    } @else {
        <div class="tw-whitespace-pre-wrap" [ngStyle]="data.customStyle">{{ data.messageLabel || 'Title' | translate : data.messageParams }}</div>
    }
</mat-dialog-content>
<mat-dialog-actions align="end" class="tw-px-5">
    <button mat-button [mat-dialog-close]="false">
        {{ data.cancelLabel || 'APPLICATION.CONFIRM_DIALOG.NO' | translate }}
    </button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial color="primary" class="tw-text-base tw-font-medium">
        {{ data.confirmLabel || 'APPLICATION.CONFIRM_DIALOG.YES' | translate }}
    </button>
</mat-dialog-actions>
